
<div fileDrop
     class="drop-zone"
     [ngClass]="{'file-is-over my-drop-zone': isFileOver}"
     [options]="options"
     (drop)="onFileDrop($event)"
     (fileOver)="isFileOver = $event">
    Drag and Drop images or
    <label for="fileInput" class="mtv-primary-color clickable-text">browse</label>
</div>

<input id="fileInput"
       name="fileInput"
       type="file"
       class="hidden"
       (change)="onFileInput($event)">



// WEBPACK FOOTER //
// /app/src/app/views/website-builder/website-builder-side-editor/common/website-builder-image-upload/website-builder-image-upload.component.html